import React from 'react';

export function ArrowRightIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
            <path d="M16.6846 5.96475L23.6588 12.939L16.6846 19.9132" stroke="black" stroke-width="1.74356"/>
            <line x1="0.560089" y1="12.9015" x2="22.5582" y2="12.9015" stroke="black" stroke-width="1.74356"/>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./src/app/components/bannerV2/ArrowRightIcon.js